import { ComputedRef, shallowRef } from 'vue'
import {
  documentAgreementRelatedDocumentCreate,
  documentAgreementRelatedDocumentDelete,
  documentAgreementRelatedDocuments,
} from '@/requests/documentAgreement'
import { openDialog } from '@/dialog'
import { handleAsync } from 'best-modules/plugins'

export function useRelatedDocuments(documentAgreementId: ComputedRef<number>) {
  const relatedDocuments = shallowRef<any[]>([])

  const getRelatedDocuments = () => {
    return documentAgreementRelatedDocuments(documentAgreementId.value).then(
      res => {
        relatedDocuments.value = res
      }
    )
  }

  const relatedDocumentCreate = () => {
    openDialog({
      name: 'SelectDocumentAgreement',
      params: {
        cb: childrenDocumentId => {
          return handleAsync('relatedDocumentCreate', async () => {
            relatedDocuments.value =
              await documentAgreementRelatedDocumentCreate({
                parentDocumentId: documentAgreementId.value,
                childrenDocumentId,
              })
          })
        },
      },
    })
  }

  const relatedDocumentDelete = (childrenDocumentId: number) => {
    return handleAsync('relatedDocumentDelete', () => {
      return documentAgreementRelatedDocumentDelete({
        parentDocumentId: documentAgreementId.value,
        childrenDocumentId,
      }).then(res => {
        relatedDocuments.value = res
      })
    })
  }

  return {
    relatedDocuments,
    getRelatedDocuments,
    relatedDocumentCreate,
    relatedDocumentDelete,
  }
}
